import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import advancedSearchFilteringTrackingService from "app/pages/sales-intelligence/modules/advanced-search-filtering/services/tracking";

import { setAppsSearchText } from "../store/action-creators";
import { selectAppsSearchText } from "../store/selectors";

type HookValue = {
    searchText: string;
    onSearchTextChange: (searchText: string) => void;
    onSearchTextClear: (searchText: string) => void;
};

export const useAppsSearchText = (): HookValue => {
    const dispatch = useDispatch();

    const searchText = useSelector(selectAppsSearchText);

    const onSearchTextChange = useCallback(
        (text: string) => {
            if (text.length > 0) {
                advancedSearchFilteringTrackingService.trackSearchFieldUsed("apps", text);
            }

            dispatch(setAppsSearchText(text));
        },
        [dispatch],
    );

    const onSearchTextClear = (text: string) => {
        advancedSearchFilteringTrackingService.trackSearchFieldCleared("apps", text);
    };

    return { searchText, onSearchTextChange, onSearchTextClear };
};
